module.exports = __webpack_public_path__ + "img/jean-michel-veyssy.e1aaf6e2.jpg";